import { defineComponent as _defineComponent } from 'vue'
import { ref, inject, computed } from 'vue';
import {
  BaseModal,
  ButtonPrimary,
  NavBar,
  SingleInput
} from '@warrenbrasil/nebraska-web';
import { CloseButton } from '@/modules/common/components/buttons';

interface Props {
  isOpenModal: boolean;
  isTemplate?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalCreateWallet',
  props: {
    isOpenModal: { type: Boolean },
    isTemplate: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'close', open: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  isOpenModal: boolean;
  isTemplate?: boolean;
}




const inputText = ref('');

const isLoading = ref(false);

const createWallet = inject('createWallet', async (name: string) => ({ name }));

const placeholderValue = computed(() => {
  return props.isTemplate ? 'Nome da carteira modelo' : 'Nome da carteira';
});

function handleChangePortfolioName(text: string) {
  if (text.trim() === '') {
    inputText.value = text.trim();
    return;
  }
  inputText.value = text;
}

async function handleCreateWallet() {
  try {
    isLoading.value = true;
    await createWallet(inputText.value ? inputText.value : 'Nova carteira');
  } finally {
    isLoading.value = false;
  }
}

function closeModal() {
  emit('close', true);
  inputText.value = '';
}

return { __sfc: true,props, emit, inputText, isLoading, createWallet, placeholderValue, handleChangePortfolioName, handleCreateWallet, closeModal, BaseModal, ButtonPrimary, NavBar, SingleInput, CloseButton }
}

})